// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import { getAttractionBySlugResponseTransformer } from './transformers.gen';
import type {
  AddExperienceToFavoriteData,
  AddExperienceToFavoriteResponses,
  GetAttractionBySlugData,
  GetAttractionBySlugErrors,
  GetAttractionBySlugResponses,
  GetExperiencesFavoritesListData,
  GetExperiencesFavoritesListResponses,
  GetSeoBffV1ExperienceListData,
  GetSeoBffV1ExperienceListResponses,
  RemoveExperienceFromFavoriteData,
  RemoveExperienceFromFavoriteResponses,
} from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<
  TData,
  ThrowOnError
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Получение списка экскурсий/туров в избранном
 */
export const getExperiencesFavoritesList = <ThrowOnError extends boolean = false>(
  options?: Options<GetExperiencesFavoritesListData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetExperiencesFavoritesListResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/experiences/favorites/',
    ...options,
  });

/**
 * Удалить экспериенс из избранного
 */
export const removeExperienceFromFavorite = <ThrowOnError extends boolean = false>(
  options: Options<RemoveExperienceFromFavoriteData, ThrowOnError>,
) =>
  (options.client ?? client).delete<RemoveExperienceFromFavoriteResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/experiences/{experienceId}/favorite/',
    ...options,
  });

/**
 * Добавить экспериенс в избранное
 */
export const addExperienceToFavorite = <ThrowOnError extends boolean = false>(
  options: Options<AddExperienceToFavoriteData, ThrowOnError>,
) =>
  (options.client ?? client).put<AddExperienceToFavoriteResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/experiences/{experienceId}/favorite/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Получить карточку достопримечательности
 *
 * BFF: GET /service/seo-bff/api/bff/v1/attraction/{slug} — описание, фото, расписание, экскурсии и достопримечательности рядом
 */
export const getAttractionBySlug = <ThrowOnError extends boolean = false>(
  options: Options<GetAttractionBySlugData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetAttractionBySlugResponses, GetAttractionBySlugErrors, ThrowOnError>({
    responseTransformer: getAttractionBySlugResponseTransformer,
    url: '/service/seo-bff/api/bff/v1/attraction/{slug}',
    ...options,
  });

/**
 * Experiences (SEO BFF)
 *
 * Пагинация экскурсий на карточке достопримечательности
 */
export const getSeoBffV1ExperienceList = <ThrowOnError extends boolean = false>(
  options?: Options<GetSeoBffV1ExperienceListData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetSeoBffV1ExperienceListResponses, unknown, ThrowOnError>({
    url: '/service/seo-bff/api/bff/v1/experiences',
    ...options,
  });
